import { createAsyncAction } from 'typesafe-actions';

import {
  AddNewDebtJournalEntriesSuccessPayload,
  GetAccountingDatesSuccessPayload,
  GetDebtJournalEntriesSuccessPayload,
  SaveAccountingDatesSuccessPayload,
  SaveDebtJournalEntriesSuccessPayload,
} from '../types';

export const getDebtJournalEntries = createAsyncAction(
  'debtJournalEntries/getDebtJournalEntries/request',
  'debtJournalEntries/getDebtJournalEntries/success',
  'debtJournalEntries/getDebtJournalEntries/failure',
)<undefined, GetDebtJournalEntriesSuccessPayload, undefined>();

export const saveDebtJournalEntries = createAsyncAction(
  'debtJournalEntries/saveDebtJournalEntries/request',
  'debtJournalEntries/saveDebtJournalEntries/success',
  'debtJournalEntries/saveDebtJournalEntries/failure',
)<undefined, SaveDebtJournalEntriesSuccessPayload, undefined>();

export const getAccountingDates = createAsyncAction(
  'debtJournalEntries/getAccountingDates/request',
  'debtJournalEntries/getAccountingDates/success',
  'debtJournalEntries/getAccountingDates/failure',
)<undefined, GetAccountingDatesSuccessPayload, undefined>();

export const saveAccountingDates = createAsyncAction(
  'debtJournalEntries/saveAccountingDates/request',
  'debtJournalEntries/saveAccountingDates/success',
  'debtJournalEntries/saveAccountingDates/failure',
)<undefined, SaveAccountingDatesSuccessPayload, undefined>();

export const addNewDebtJournalEntries = createAsyncAction(
  'debtJournalEntries/addNewDebtJournalEntries/request',
  'debtJournalEntries/addNewDebtJournalEntries/success',
  'debtJournalEntries/addNewDebtJournalEntries/failure',
)<undefined, AddNewDebtJournalEntriesSuccessPayload, undefined>();
